import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ec65bdc8 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _32b4549d = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _f8cc2ad2 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _1db77ee0 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _e967da86 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _e94bab84 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _e9134d80 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _e8f71e7e = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _7f9b6404 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _5552f878 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _d4cd3fca = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _55d86764 = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _971b02b6 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _460702e6 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _ec65bdc8,
    name: "error"
  }, {
    path: "/rejection",
    component: _32b4549d,
    name: "rejection"
  }, {
    path: "/success",
    component: _f8cc2ad2,
    name: "success"
  }, {
    path: "/unlock",
    component: _1db77ee0,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _e967da86,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _e94bab84,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _e9134d80,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _e8f71e7e,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _7f9b6404,
    name: "errors-500"
  }, {
    path: "/patient/eligibility",
    component: _5552f878,
    name: "patient-eligibility"
  }, {
    path: "/patient/patient-information",
    component: _d4cd3fca,
    name: "patient-patient-information"
  }, {
    path: "/pharmacy/eligibility",
    component: _55d86764,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/patient-information",
    component: _971b02b6,
    name: "pharmacy-patient-information"
  }, {
    path: "/",
    component: _460702e6,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
